export enum SalonActionTypes {
  FETCH_REQUEST = '@@salon/FETCH_REQUEST',
  FETCH_SUCCESS = '@@salon/FETCH_SUCCESS',
  FETCH_ERROR = '@@salon/FETCH_ERROR'
}

export interface SalonAddress {
  id: number
  guid: string
  refSalonId: number
  strasse: string
  plz: string
  stadt: string
}

export interface SalonOpeningHours {
  id: number
  guid: string
  refSalonId: number
  sortIndex: number
  refTageId: number
  öffnungszeit: string
  schließzeit: string
}

export interface SalonContactData {
  id: number
  guid: string
  refSalonId: number
  email: string
  tel: string
  mobil: string
  facebook: string
  instagram: string
  whatsApp: string
  tikTok: string
  youTube: string
}

export interface Salon {
  id: number
  guid: string
  name: string
  domain: string
  erstellungsdatum: string
  öffnungszeiten: SalonOpeningHours[]
  address: SalonAddress
  absageZeit: number // Number of hours before an appointment cannot be cancelled anymore
  kontakt: SalonContactData
  logoPath: string
  headImgPath?: string
}

export interface SalonState {
  readonly loading: boolean
  readonly data?: Salon
  readonly errors?: string
}
